import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'fury-send-reminder-dialog',
  templateUrl: './send-reminder-dialog.component.html',
  styleUrls: ['./send-reminder-dialog.component.scss'],
})

export class SendReminderDialogComponent implements OnDestroy {

  @Output() submitData: EventEmitter<any> = new EventEmitter<any>();

  public isLoading: boolean = false;

  public form = this.fb.group({
    note: new FormControl(<string>''),
  });

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private fb: FormBuilder,
  ) {
  }

  submit(formData: any): void {
    this.submitData.emit(formData);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.isLoading = false;
  }
}
